export default __webpack_public_path__ + "static/media/login.c6cf1f14.jpg";